<template>
  <div class="container-social-media-posts">
    <ModalLoading :show="showModalLoading" @close="closeModal" />
    <div style="display: flex; align-items: center">
      <span class="social-media-posts-title"> Postagens em alta </span>
      <!-- <Badge
        v-if="!isSearching && localMedias.length > 0"
        :value="localMedias.length"
        :title="buildTitle()"
        style="cursor: pointer"
        class="ml-2"
      ></Badge> -->
    </div>
    <div class="social-medias-icons-container" v-if="!isSearching">
      <i
        v-if="this.medias.length"
        class="fa-brands fa-instagram"
        :class="{ 'instagram-colored': instagramActive }"
        style="font-size: 1.5rem"
        @click="toggleInstagram"
      ></i>
      <i
        v-if="this.tiktokData.length"
        class="fa-brands fa-tiktok"
        :class="{ 'tiktok-colored': tiktokActive }"
        style="font-size: 1.5rem"
        @click="toggleTiktok"
      ></i>
    </div>
    <span v-if="this.days > 0" class="social-media-posts-subtitle">
      Nos últimos {{ this.days }} dias</span
    >
    <CustomSkeleton v-if="isSearching" type="card" :count="2" />
    <div v-if="!isSearching" class="content-social-media-posts">
      <div v-for="media in filteredMedias" :key="media.id">
        <CardPosts
          :social-media-type="instagramActive ? 'instagram' : 'tiktok'"
          :media="media"
          :medias="filteredMedias"
          :socialMediaType="socialMediaType"
          @update:medias="updateMedias($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomSkeleton from '@/Shared/CustomSkeleton'
import CardPosts from './Components/CardPosts'
import ModalLoading from './ModalLoading.vue'
import Badge from 'primevue/badge'
import axios from 'axios'

export default {
  props: {
    isSearching: Boolean,
    medias: Array,
    tiktokData: Array,
    days: Number,
    term: Number,
    mediaPagination: String,
  },
  data() {
    return {
      isLoadingMore: false,
      showModalLoading: false,
      nextCursor: null,
      hasMorePages: true,
      hasReachedEnd: false,
      localMedias: [],
      instagramActive: true,
      tiktokActive: false,
      isInitialLoad: true,
      socialMediaType: 'instagram',
    }
  },
  components: {
    CardPosts,
    CustomSkeleton,
    Badge,
    ModalLoading,
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.medias?.length) {
          this.toggleInstagram()
        } else {
          this.toggleTiktok()
        }
        const scrollContainer = this.$el.querySelector('.content-social-media-posts')
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', this.handleScroll)
        }
      }, 500)
    })
  },

  beforeDestroy() {
    const scrollContainer = this.$el.querySelector('.content-social-media-posts')
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
  },

  updated() {
    this.hasReachedEnd = false

    this.$nextTick(() => {
      const scrollContainer = this.$el.querySelector('.content-social-media-posts')
      if (scrollContainer) {
        this.handleScroll({ target: scrollContainer })
      }
    })
  },
  computed: {
    filteredMedias() {
      if (this.instagramActive) {
        return this.localMedias
      } else if (this.tiktokActive) {
        return this.tiktokData
      }
      return this.localMedias
    },
  },
  methods: {
    buildTitle() {
      return `Total de postagens no período selecionado: ${this.localMedias.length}`
    },
    closeModal() {
      this.showModalLoading = false
    },
    toggleInstagram() {
      this.instagramActive = true
      this.tiktokActive = false
      this.socialMediaType = 'instagram'
    },

    toggleTiktok() {
      this.tiktokActive = true
      this.instagramActive = false
      this.socialMediaType = 'tiktok'
    },
    addScrollListener() {
      this.$nextTick(() => {
        setTimeout(() => {
          const scrollContainer = this.$el.querySelector('.content-social-media-posts')
          if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', this.handleScroll) // Garante que não há duplicação
            scrollContainer.addEventListener('scroll', this.handleScroll)
          }
        }, 300)
      })
    },

    handleScroll(event) {
      if (this.isInitialLoad) {
        this.isInitialLoad = false
        return
      }

      const container = event.target
      if (!container || this.isLoadingMore || !this.hasMorePages || this.tiktokActive) return

      const scrollLeft = container.scrollLeft
      const maxScrollLeft = container.scrollWidth - container.clientWidth

      const isAtEnd = scrollLeft >= maxScrollLeft - 10

      if (isAtEnd && !this.hasReachedEnd) {
        this.hasReachedEnd = true
        this.loadMoreMedias()
      } else if (!isAtEnd) {
        this.hasReachedEnd = false
      }
    },

    async loadMoreMedias() {
      if (this.isLoadingMore) return

      try {
        this.isLoadingMore = true
        this.showModalLoading = true

        const response = await axios.post('/api/social-media/search/medias', {
          value: this.term,
          after: this.mediaPagination,
        })

        const newMedias = response.data.medias || []

        // Adicionar novos itens sem sobrescrever
        this.localMedias = [...this.localMedias, ...newMedias]
        this.$emit('update:medias', this.localMedias)

        this.hasMorePages = Boolean(this.mediaPagination)
      } catch (error) {
        console.error('Erro ao carregar mais postagens:', error)
        this.isLoadingMore = false
        this.showModalLoading = false
      } finally {
        this.isLoadingMore = false
        this.showModalLoading = false
      }
    },
  },

  watch: {
    medias(newMedias) {
      this.localMedias = [...newMedias]
      this.hasReachedEnd = false
      this.addScrollListener()
      if (this.medias?.length) {
        this.toggleInstagram()
      } else {
        this.toggleTiktok()
      }
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
